import { cn } from "@/lib/utils";

export function SectionHeading({ overline, title, description, align = "left", light = false, className }) {
  return (
    <div
      className={cn(
        "max-w-2xl",
        align === "center" && "mx-auto text-center",
        className
      )}
    >
      {overline && <p className={cn("overline mb-3", light && "text-gold")}>{overline}</p>}
      <h2 className={cn("font-heading text-3xl lg:text-4xl font-semibold tracking-tight leading-tight", light ? "text-white" : "text-ink")}>
        {title}
      </h2>
      {description && (
        <p className={cn("mt-4 text-base lg:text-lg leading-relaxed", light ? "text-slate-300" : "text-subtle")}>
          {description}
        </p>
      )}
    </div>
  );
}
